import { useLoader } from "@react-three/fiber";
import * as THREE from "three";

export interface PillarProps {
  position: [number, number, number];
  rotationZ?: number;
}

export function Pillar({ position, rotationZ = 0 }: PillarProps) {
  const texture = useLoader(THREE.TextureLoader, "./images/pillar.png");
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.minFilter = THREE.NearestFilter;
  texture.magFilter = THREE.NearestFilter;

  return (
    <mesh position={position} rotation-z={rotationZ}>
      <boxGeometry args={[1, 12, 1]} />
      <meshBasicMaterial map={texture} side={THREE.DoubleSide} transparent />
    </mesh>
  );
}
